// extracted by mini-css-extract-plugin
export default {"container":"IL-z","modal":"JL-z","dimensions":"KL-z","brandName":"LL-z","productName":"ML-z","labelValue":"NL-z","recipientEmail":"OL-z","recommendedFit":"PL-z","hiddenField":"QL-z"};